export default (data) => ({
  type: 'ACADA_SHOW_POPUP',
  payload: data,
});
